import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles, categories } from "@/mocks/articles";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <main>
        <Navbar />
        <div className="flex flex-col items-center justify-center min-h-[60vh] pt-20">
          <i className="ri-emotion-sad-line text-5xl text-foreground-300 mb-4"></i>
          <h1 className="text-xl font-semibold text-foreground-950 mb-2">分类不存在</h1>
          <Link to="/" className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer">
            返回首页继续吃瓜
          </Link>
        </div>
        <Footer />
      </main>
    );
  }

  const heroImageUrl = categoryArticles[0]?.heroImageUrl || categoryArticles[0]?.imageUrl || "";

  return (
    <main>
      <Navbar />

      <section className="relative w-full h-[380px] md:h-[480px] overflow-hidden">
        <div className="absolute inset-0">
          {heroImageUrl ? (
            <img
              src={heroImageUrl}
              alt={category.name}
              title={`${category.name} - 今日大瓜`}
              className="w-full h-full object-cover object-top"
            />
          ) : (
            <div className="w-full h-full bg-background-200"></div>
          )}
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

        <div className="relative z-10 flex flex-col justify-center h-full w-full px-6 md:px-14">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-2xl bg-white/15 backdrop-blur-sm flex items-center justify-center">
              <i className={`${category.icon} text-xl text-white`}></i>
            </div>
            <span className="text-white/80 text-sm font-medium">{categoryArticles.length} 篇瓜料</span>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-3">
            {category.name}
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-lg">
            {category.description}
          </p>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="px-6 md:px-14">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-10">
            {category.name} · 全部瓜料
          </h2>

          {categoryArticles.length === 0 ? (
            <div className="text-center py-20">
              <i className="ri-inbox-line text-4xl text-foreground-300 mb-3"></i>
              <p className="text-foreground-500">这个分类暂时还没有瓜料，去看看其他的吧</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {categoryArticles.map((article, idx) => (
                <div key={article.id} className={idx === 0 ? "sm:col-span-2 lg:col-span-2" : ""}>
                  <Link
                    to={`/article/${article.slug}`}
                    className={`group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all duration-300 cursor-pointer h-full`}
                  >
                    <div className="relative">
                      {idx === 0 && article.tag && (
                        <span className="absolute top-3 left-3 z-10 px-3 py-1 rounded-full bg-foreground-950 text-background-50 text-xs font-medium">
                          {article.tag}
                        </span>
                      )}
                      <div className={`w-full ${idx === 0 ? "h-[240px]" : "h-[180px]"} overflow-hidden`}>
                        <img
                          src={article.imageUrl}
                          alt={article.title}
                          title={`${article.title} - 今日大瓜`}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div className="p-4">
                      <h3 className={`font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2 ${idx === 0 ? "text-base md:text-lg" : "text-sm"}`}>
                        {article.title}
                      </h3>
                      {idx === 0 && (
                        <p className="text-xs text-foreground-500 mt-2 line-clamp-2">{article.summary}</p>
                      )}
                      <div className="flex items-center justify-between text-xs text-foreground-500 mt-3">
                        <span>{article.date}</span>
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line text-xs"></i>
                          {article.views}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </main>
  );
}